/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

import { connect } from 'react-redux';
import { modelTypesByForm } from '#src/js/constants/models/modelTypes/index.js';
import YearOfConstructionOrCodeYear from './YearOfConstructionOrCodeYear.jsx';

const mapStateToProps = (state, props) => {
  const { form, yearOfConstructionName } = props;

  const { selectFormFieldVisibility, selectIsCountryUS, selectIsCountryJapan } =
    modelTypesByForm[form];

  const isCountryJapan = selectIsCountryJapan(state);
  const isCountryUS = selectIsCountryUS(state);

  return {
    useYearOfConstruction: !!selectFormFieldVisibility(state)(yearOfConstructionName),
    showDesignCodeYearToggle: !isCountryJapan,
    showYearOfConstructionToggle: isCountryUS,
  };
};

export default connect(mapStateToProps)(YearOfConstructionOrCodeYear);
